/**
 * Account Tabs Component
 *
 * Tab navigation for account management sections
 */

import { useTranslation } from 'react-i18next';

type TabType = 'personal' | 'security' | 'settings' | 'history' | 'payment';

interface AccountTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export function AccountTabs({ activeTab, onTabChange }: AccountTabsProps) {
  const { t } = useTranslation();

  const tabs = [
    { id: 'personal' as TabType, label: t('account.tabs.personal'), icon: 'person' },
    { id: 'security' as TabType, label: t('account.tabs.security'), icon: 'lock' },
    { id: 'settings' as TabType, label: t('account.tabs.settings'), icon: 'settings' },
    { id: 'history' as TabType, label: t('account.tabs.history'), icon: 'history' },
    { id: 'payment' as TabType, label: t('account.tabs.payment'), icon: 'payments' },
  ];

  return (
    <div className='mb-8 border-b border-border-light dark:border-border-dark'>
      <div className='flex gap-8 overflow-x-auto'>
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 border-b-[3px] pb-3 px-1 text-sm whitespace-nowrap transition-colors ${
              activeTab === tab.id
                ? 'border-primary text-gray-900 dark:text-gray-100 font-bold'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 font-medium'
            }`}
            aria-selected={activeTab === tab.id}
            role='tab'
          >
            <span className='material-symbols-outlined text-[20px]'>{tab.icon}</span>
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
